import React from 'react';
import { Link } from "gatsby";
import Layout from "../../layouts/en";
import eventCover from '../../images/event-logo.jpg';

export default function Home(props) {
  return (
    <Layout
      location={props.location}
      title="Event Logo Design and Pitching Competition"
    >
      <div className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <nav class="mb-4">
            <Link to="/">Home</Link>
            <span class="mx-3 text-gray-700">/</span>
            <span class="text-gray-500">
              Event Logo Design and Pitching Competition
            </span>
          </nav>

          <div className="mt-5">
            <h1 className="text-2xl font-bold">
              Event Logo Design and Pitching Competition
            </h1>

            <div className="mt-5 leading-loose">
              <div>
                <img
                  src={eventCover}
                  className="rounded h-48 lg:float-right lg:block hidden"
                  alt=""
                />
                <p>
                  “Event Logo Design and Pitching Competition” is one of the
                  activities of EI Fiesta, which is organised by
                  Entrepreneurship and Innovation Education Unit of The
                  Education University of Hong Kong Library and funded by the
                  University Grants Committee (UGC).
                </p>
                <p className="mt-3">
                  The purpose of the Competition is to design a logo for EI
                  Fiesta. The selected logo may be used in all media, including
                  online, print, giveaways, and other visual collateral.
                  Students will also have a chance to elaborate on their design
                  concepts through the pitching videos.
                </p>
              </div>
              <div className="mt-10">
                <h3 className="font-bold text-lg">Eligibility</h3>
                <p>
                  All EdUHK students are welcome to join the competition either
                  as individuals or in teams. Each student or student group may
                  submit at most two entries, i.e. two designs.
                </p>
              </div>
              <div className="mt-10">
                <h3 className="font-bold text-lg">Awards</h3>
                <p>
                  Individuals or teams can submit the logo design(s) and its
                  pitching video to compete for:
                </p>
                <table class="w-full bg-orange-50 table-fixed my-3">
                  <thead>
                    <tr>
                      <th class="border border-black px-2 py-2 text-left">
                        Award
                      </th>
                      <th class="border border-black px-2 py-2 text-left">
                        Judging Mechanism
                      </th>
                      <th class="border border-black px-2 py-2 text-left">
                        Recognition
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="border border-black px-2 py-2">
                        “Best Logo Design Award”
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        A Judging Panel comprised of the Library and Academic
                        Staff will evaluate all entries based on the following
                        criteria:
                        <ul className="list-disc ml-5">
                          <li>
                            Relevance with the theme and objectives of EI Fiesta
                            (40%)
                          </li>
                          <li>Originality & Creativity (30%)</li>
                          <li>Aesthetic Quality (30%)</li>
                        </ul>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <ul className="list-disc ml-5">
                          <li>$1,500 Eslite book coupon and certificate</li>
                          <li>
                            The logo will be used to produce giveaway incentives
                            and in upcoming activity promotion
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td class="border border-black px-2 py-2">
                        “Best Pitching Award”
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        A Judging Panel comprised of the Library and Academic
                        Staff will evaluate all entries based on the following
                        criteria:
                        <ul className="list-disc ml-5">
                          <li>Clarity of the Design Concepts (40%)</li>
                          <li>Confidence and Assertiveness (40%)</li>
                          <li>Audience Engagement (20%)</li>
                        </ul>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        $1,500 Eslite book coupon and certificate
                      </td>
                    </tr>
                    <tr>
                      <td class="border border-black px-2 py-2">
                        “People’s Choice Award”
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        Eligible logo designs will be posted on EIEU’s Instagram
                        page for voting from 22 April 2022 to 12 noon, 28 April
                        2022. The logo design with the most “likes” will be
                        awarded
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        $1,500 Eslite book coupon and certificate
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-10">
                <h3 className="font-bold text-lg">Schedule & Timeline</h3>
                <table class="w-full bg-orange-50 table-auto my-3">
                  <tbody>
                    <tr>
                      <td width="33%" class="border border-black px-2 py-2">
                        <b>5pm, 20 April 2022</b>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <b>Submission Deadline: 5pm, 20 April 2022</b>
                        <p>
                          Interested individuals or teams should complete the{" "}
                          <a
                            href="https://eduhk.au1.qualtrics.com/jfe/form/SV_8BTdHu8eQI5TY8K"
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 hover:text-blue-700 underline"
                          >
                            Entry Form
                          </a>{" "}
                          together with
                        </p>
                        <ul className="list-disc ml-5">
                          <li>the logo design in .jpeg or .png; and</li>
                          <li>
                            a <i>1-min pitching</i> video* (in .mpeg or .mp4
                            format) to illustrate your ideas and design
                            concepts.
                          </li>
                        </ul>
                        <p className="mt-3">
                          Individuals or teams may submit <u>at most</u> two
                          entries.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td width="33%" class="border border-black px-2 py-2">
                        <b>22 April 2022 to 12 noon, 28 April 2022</b>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <b>Voting for the People’s Choice Award</b>
                        <p>
                          Eligible logo designs will be posted on EIEU’s
                          Instagram page for voting.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td width="33%" class="border border-black px-2 py-2">
                        <b>29 April 2022</b>
                      </td>
                      <td class="border border-black px-2 py-2 leading-normal">
                        <b>Results Announcement</b>
                        <p>
                          The awardee list of the “Best Logo Design Award”,
                          “Best Pitching Award” and “People Choice’s Award” will
                          be posted on the EIEU website.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  * Interested individuals or teams are encouraged to join the “
                  <Link
                    to="/activities/workshop-effective-presentation-storytelling-skills"
                    className="text-blue-600 hover:text-blue-700 underline"
                  >
                    Workshop on Effective Presentation and Storytelling Skills
                  </Link>
                  ” on 11 April 2022.
                </p>
              </div>

              <div className="mt-10">
                <h3 className="font-bold text-lg">Submission of your work</h3>
                <p>
                  Interested individuals or teams should complete the Entry Form
                  below on or before 5pm, 20 April 2022.
                </p>
                <a
                  href="https://eduhk.au1.qualtrics.com/jfe/form/SV_8BTdHu8eQI5TY8K"
                  className="cta mt-2 inline-block"
                  target="_blank"
                  rel="noreferrer"
                >
                  Submit the Entry Form
                </a>
              </div>

              <div className="mt-10" id="regulations">
                <h3 className="font-bold text-lg">Regulations</h3>
                <div className="mt-3 pl-5">
                  <ol className="list-decimal regulations">
                    <li>
                      Each individual or team may submit no more than two
                      entries. Any extra entries will not be considered.
                    </li>
                    <li>
                      All entries must be the original work and must not
                      include, be based on, or derived from any pre-existing or
                      third-party designs, patents, trademarks, or copyrighted
                      images.
                    </li>
                    <li>
                      All entries with illegal elements will not be considered.
                      All items submitted must fully comply with all laws of
                      Hong Kong, and must not:
                      <ol className="list-alpha pl-5">
                        <li>
                          contain any indecent, provocative, defamatory and
                          hate-spreading contents;
                        </li>
                        <li>promote illegal behavior;</li>
                        <li>
                          support racial, religious, sexual or other invidious
                          prejudice;
                        </li>
                        <li>advocate sexual or violent exploitation;</li>
                        <li>violate rights established by law or agreement;</li>
                        <li>invade the privacy of any person; or</li>
                        <li>
                          be otherwise inappropriate as determined by EIEU.
                        </li>
                      </ol>
                    </li>
                    <li>
                      All entries will become the property of Entrepreneurship
                      and Innovation Education Unit (EIEU), The Education
                      University of Hong Kong Library.
                    </li>
                    <li>
                      By submitting an entry, the participant(s) agree(s) that
                      <ol className="list-alpha pl-5">
                        <li>
                          any and all intellectual property rights in the logo
                          design are deemed assigned to EIEU and
                        </li>
                        <li>
                          name of the participant(s), prize information,
                          pitching video and information provided on the Entry
                          Form can be used for publicity without further
                          permission or compensation.
                        </li>
                      </ol>
                    </li>
                    <li>
                      EIEU reserves the right to modify and edit the selected
                      logo (“Best Logo Design” ) to better fit the event and to
                      reject any submission based on absolute sole discretion
                      without assigning any reasons.
                    </li>
                    <li>
                      A high-resolution vector file (e.g., in Adobe Illustrator,
                      Photoshop, or InDesign) of the winning logo (“Best Logo
                      Design”) MUST be submitted so that it is adaptable to
                      electronic and print media, to reproduction on small and
                      large surfaces, and to uses in colour or in grayscale.
                    </li>
                    <li>
                      The winning logo (“Best Logo Design”) will be used to
                      produce giveaway incentives and upcoming promotional
                      materials for EI Fiesta or other purposes as EIEU deems
                      appropriate.
                    </li>
                    <li>
                      The decisions of the Judging Panel will be final. In case
                      of disputes, EIEU shall have the right to the final
                      decision.
                    </li>
                    <li>
                      The Judging Panel reserves the right not to select a
                      winning logo for the “Best Logo Design Award”, if at its
                      sole discretion, no suitable entries are received.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
